import axios from "axios";
import router from "../router";
import alert from "@/plugins/AlertMessages.js";

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
axios.defaults.headers.common["Content-Type"] = "application/json";
// axios.defaults.headers.common['Accept-Language'] = 'en-US';
axios.defaults.headers.common["Accept-Language"] = "fa";

const panelXios = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
});
panelXios.defaults.headers.common["Content-Type"] = "application/json";
panelXios.defaults.headers.common["Authorization"] =
  "Bearer " + localStorage.panelToken;

export default {
  // ContactUs & Resume Branch Requests --------------------------------------------
  contactUs({ dispatch, commit }, data) {
    axios
      .post("Client/ContactUs", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.send,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false);
      });
  },

  sendBranch({ dispatch, commit }, data) {
    axios
      .post("Client/Branch", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.send,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false);
      });
  },
  sendResume({ dispatch, commit }, data) {
    axios
      .post("Client/Resume", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.send,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false);
      });
  },

  // Alert and Errors Handler ------------------------------------------------------
  successPOSTHandler({ commit }, data) {
    if (data.server && data.server.status === 200) {
      commit("setSuccess", data.message, { root: true });
      commit("setPostCheck", true, { root: true });
      setTimeout(() => {
        commit("setPostCheck", false, { root: true });
      }, 800);
      if (data.redirect) {
        setTimeout(() => {
          router.push({ name: data.redirect });
        }, 2500);
      }
    } else if (data.server.data && data.server.data.message != "") {
      commit("setError", data.server.data.message, { root: true });
      commit("setPostCheck", false, { root: true });
    } else {
      commit("setError", alert.error.post, { root: true });
      commit("setPostCheck", false, { root: true });
    }
  },

  errorPOSTHandler({ dispatch, commit }, data) {
    commit("setPostCheck", false, { root: true });
    if (data.response && data.response.status === 403) {
      commit("setError", alert.error.access, { root: true });
    } else if (data.response && data.response.status === 401) {
      dispatch("panelX/logout");
    } else if (data.response.data.message && data.response.data.message != "") {
      commit("setError", data.response.data.message, { root: true });
    } else {
      commit("setError", alert.error.server, { root: true });
    }
  },

  errorGETHandler({ dispatch, commit }, data) {
    commit("setPostCheck", false, { root: true });
    if (data.response && data.response.status === 403) {
      dispatch("panelX/logout");
      router.push({ name: "Page403" });
    } else if (data.response && data.response.status === 401) {
      dispatch("panelX/logout");
    } else if (data.response.data.message && data.response.data.message != "") {
      commit("setError", data.response.data.message, { root: true });
    } else {
      commit("setError", alert.error.server, { root: true });
    }
  },

  getCaptcha({ commit }) {
    axios
      .get("Account/CreateCaptcha", { withCredentials: true })
      .then((res) => {
        commit("setCaptcha", res.data);
      })
      .catch(() => {
        commit("setError", alert.error.loadCaptcha, { root: true });
      });
  },
  getClientCaptcha({ commit }) {
    axios
      .get("Client/ClientCaptcha/CreateCaptcha", { withCredentials: true })
      .then((res) => {
        commit("setCaptcha", res.data);
      })
      .catch(() => {
        commit("setError", alert.error.loadCaptcha, { root: true });
      });
  },
};
